import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const policyLinks = [
    { name: 'Contact Us', url: 'https://supplebakes.com/contact-us/' },
    { name: 'Terms of Use', url: 'https://supplebakes.com/terms-of-use/' },
    { name: 'Privacy Policy', url: 'https://supplebakes.com/privacy-policy/' },
    { name: 'Refund Policy', url: 'https://supplebakes.com/refund-policy/' },
    { name: 'Shipping Policy', url: 'https://supplebakes.com/shipping-policy/' }
  ];

  const openExternalLink = (url) => {
    if (window.cordova && window.cordova.InAppBrowser) {
      window.cordova.InAppBrowser.open(url, '_system');
    } else {
      window.open(url, '_blank');
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="container">
          {/* Policy Links */}
          <div className="footer-section">
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-links">
              {policyLinks.map((link, index) => (
                <li key={index}>
                  <button 
                    onClick={() => openExternalLink(link.url)}
                    className="footer-link"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Divider */}
          <div className="footer-divider"></div>

          {/* Developed By */}
          <div className="footer-branding">
            <p className="footer-text">Developed & Managed by</p>
            <button 
              onClick={() => openExternalLink('https://woocoders.com/')}
              className="brand-link"
            >
              <img 
                src="https://woocoders.com/wp-content/uploads/2020/02/woocoders_logo.svg" 
                alt="WOOCODERS" 
                className="brand-logo"
              />
            </button>
          </div>

          {/* Copyright */}
          <div className="footer-copyright">
            <p>© {currentYear} Supple Bakes. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
